import commonJsModule from "read-file-string"

export default commonJsModule.default